import { useSelector } from "react-redux"
import isNull from "../../utils/NullChecking"



const HandleStatus = ({ Status, RejectionReason }) => {
    let DropDowns = useSelector(state => state.GeneralDropDownsReducer)
    // let DropDowns = []

    const getColorCode = (status) => {
        if (!isNull(status) && !isNull(DropDowns.BillingStatus)) {
            let color = DropDowns?.BillingStatus.filter(item => item.value === status)[0]
            return color?.ColorCode || ""
        } else {
            return ""
        }
    }
    const hexToRgb = (status) => {
        let hex = getColorCode(status)
        if (hex) {
            hex = hex.replace('#', '');
            let bigint = parseInt(hex, 16);
            let r = (bigint >> 16) & 255;
            let g = (bigint >> 8) & 255;
            let b = bigint & 255;
            return `${r}, ${g}, ${b}`;
        } else {
            return ""
        }
    };
    let trimmedStatus = typeof Status === "string" ? Status.trim() : Status;
    switch (trimmedStatus) {
        case 'Missing Info':
            return <div className="app_tooltip bottom grossary description claimStatus">
                <p className='Missing-Info ar-status-clm heading'>{Status}</p>
                {!isNull(RejectionReason) ? <p className="tool_tip">
                    <span className='xsm_text text-light  multi-line-truncate text-wrap overflow-hidden' title={RejectionReason}> {RejectionReason}</span>
                </p> : null}
            </div>
        case 'In Review':
            return <div className="app_tooltip bottom grossary description claimStatus"><p className='In-Review heading ar-status-clm'>{Status}</p>
                {!isNull(RejectionReason) ? <p className="tool_tip">
                    <span className='xsm_text text-light  multi-line-truncate text-wrap overflow-hidden' title={RejectionReason}> {RejectionReason}</span>
                </p> : null}
            </div>
        case 'Hold':
            return <div className="app_tooltip bottom grossary description claimStatus">
                <p className='Hold heading ar-status-clm'>{Status}</p>
                {!isNull(RejectionReason) ? <p className="tool_tip">
                    <span className='xsm_text text-light  multi-line-truncate text-wrap overflow-hidden' title={RejectionReason}> {RejectionReason}</span>
                </p> : null}
            </div>
        case 'New':
            return <div className="app_tooltip bottom grossary description claimStatus">
                <p className='New heading ar-status-clm'>{Status}</p>
                {!isNull(RejectionReason) ? <p className="tool_tip">
                    <span className='xsm_text text-light  multi-line-truncate text-wrap overflow-hidden' title={RejectionReason}> {RejectionReason}</span>
                </p> : null}
            </div>
        case 'Submitted':
            return <div className="app_tooltip bottom grossary description claimStatus">
                <p className='Submitted heading ar-status-clm'>{Status}</p>
                {!isNull(RejectionReason) ? <p className="tool_tip">
                    <span className='xsm_text text-light  multi-line-truncate text-wrap overflow-hidden' title={RejectionReason}> {RejectionReason}</span>
                </p> : null}
            </div>
        case 'MARK_AS_SUBMITTED':
            return <div className="app_tooltip bottom grossary description claimStatus">
                <p className='Submitted heading ar-status-clm'>{Status}</p>
                {!isNull(RejectionReason) ? <p className="tool_tip">
                    <span className='xsm_text text-light  multi-line-truncate text-wrap overflow-hidden' title={RejectionReason}> {RejectionReason}</span>
                </p> : null}
            </div>
        case 'Acknowledged by CH':
            return <div className="app_tooltip bottom grossary description claimStatus">
                <p className='Acknowledged-by-CH heading ar-status-clm'>{Status}</p>
                {!isNull(RejectionReason) ? <p className="tool_tip">
                    <span className='xsm_text text-light  multi-line-truncate text-wrap overflow-hidden' title={RejectionReason}> {RejectionReason}</span>
                </p> : null}
            </div>
        case 'Rejected by CH':
            return <div className="app_tooltip bottom grossary description claimStatus">
                <p className='Rejected-by-CH heading ar-status-clm'>{Status}</p>
                {!isNull(RejectionReason) ? <p className="tool_tip">
                    <span className='xsm_text text-light  multi-line-truncate text-wrap overflow-hidden' title={RejectionReason}> {RejectionReason}</span>
                </p> : null}
            </div>
        case 'Forwarded to Payer':
            return <div className="app_tooltip bottom grossary description claimStatus">
                <p className='Forwarded-to-Payer heading ar-status-clm'>{Status}</p>
                {!isNull(RejectionReason) ? <p className="tool_tip">
                    <span className='xsm_text text-light  multi-line-truncate text-wrap overflow-hidden' title={RejectionReason}> {RejectionReason}</span>
                </p> : null}
            </div>
        case 'Received by Payer':
            return <div className="app_tooltip bottom grossary description claimStatus">
                <p className='Received-by-Payer heading ar-status-clm'>{Status}</p>
                {!isNull(RejectionReason) ? <p className="tool_tip">
                    <span className='xsm_text text-light  multi-line-truncate text-wrap overflow-hidden' title={RejectionReason}> {RejectionReason}</span>
                </p> : null}
            </div>
        case 'Accepted by Payer':
            return <div className="app_tooltip bottom grossary description claimStatus">
                <p className='Accepted-by-Payer heading ar-status-clm'>{Status}</p>
                {!isNull(RejectionReason) ? <p className="tool_tip">
                    <span className='xsm_text text-light  multi-line-truncate text-wrap overflow-hidden' title={RejectionReason}> {RejectionReason}</span>
                </p> : null}
            </div>
        case 'Rejected by Payer':
            return <div className="app_tooltip bottom grossary description claimStatus">
                <p className='Rejected-by-Payer heading ar-status-clm'>{Status}</p>
                {!isNull(RejectionReason) ? <p className="tool_tip">
                    <span className='xsm_text text-light  multi-line-truncate text-wrap overflow-hidden' title={RejectionReason}> {RejectionReason}</span>
                </p> : null}
            </div>
        case 'Paid':
            return <div className="app_tooltip bottom grossary description claimStatus">
                <p className='Paid heading ar-status-clm'>{Status}</p>
                {!isNull(RejectionReason) ? <p className="tool_tip">
                    <span className='xsm_text text-light  multi-line-truncate text-wrap overflow-hidden' title={RejectionReason}> {RejectionReason}</span>
                </p> : null}
            </div>
        case 'Denied':
            return <div className="app_tooltip bottom grossary description claimStatus">
                <p className='Denied heading ar-status-clm '>{Status}</p>
                {!isNull(RejectionReason) ? <p className="tool_tip">
                    <span className='xsm_text text-light  multi-line-truncate text-wrap overflow-hidden' title={RejectionReason}> {RejectionReason}</span>
                </p> : null}
            </div>
        case 'WriteOff':
            return <div className="app_tooltip bottom grossary description claimStatus">
                <p className='WriteOff heading ar-status-clm'>{Status}</p>
                {!isNull(RejectionReason) ? <p className="tool_tip">
                    <span className='xsm_text text-light  multi-line-truncate text-wrap overflow-hidden' title={RejectionReason}> {RejectionReason}</span>
                </p> : null}
            </div>
        case 'Due Patient':
            return <div className="app_tooltip bottom grossary description claimStatus">
                <p className='DuePatient heading ar-status-clm'>{Status}</p>
                {!isNull(RejectionReason) ? <p className="tool_tip">
                    <span className='xsm_text text-light  multi-line-truncate text-wrap overflow-hidden' title={RejectionReason}> {RejectionReason}</span>
                </p> : null}
            </div>
        case 'Partial Paid':
            return <div className="app_tooltip bottom grossary description claimStatus">
                <p className='Paid heading ar-status-clm'>{Status}</p>
                {!isNull(RejectionReason) ? <p className="tool_tip">
                    <span className='xsm_text text-light  multi-line-truncate text-wrap overflow-hidden' title={RejectionReason}> {RejectionReason}</span>
                </p> : null}
            </div>
        case 'Partial Denied':
            return <div className="app_tooltip bottom grossary description claimStatus">
                <p className='Partialdenied heading ar-status-clm'>{Status}</p>
                {!isNull(RejectionReason) ? <p className="tool_tip">
                    <span className='xsm_text text-light  multi-line-truncate text-wrap overflow-hidden' title={RejectionReason}> {RejectionReason}</span>
                </p> : null}
            </div>
        case 'Secondary Claim':
            return <div className="app_tooltip bottom grossary description claimStatus">
                <p className='Secondaryclaim heading ar-status-clm'>{Status}</p>
                {!isNull(RejectionReason) ? <p className="tool_tip">
                    <span className='xsm_text text-light  multi-line-truncate text-wrap overflow-hidden' title={RejectionReason}> {RejectionReason}</span>
                </p> : null}
            </div>
        case 'ReSubmit':
            return <div className="app_tooltip bottom grossary description claimStatus">
                <p className='ReSubmit heading ar-status-clm'>{Status}</p>
                {!isNull(RejectionReason) ? <p className="tool_tip">
                    <span className='xsm_text text-light  multi-line-truncate text-wrap overflow-hidden' title={RejectionReason}> {RejectionReason}</span>
                </p> : null}
            </div>
        case 'Batch Rejected':
            return <div className="app_tooltip bottom grossary description claimStatus">
                <p className='Rejected-by-CH heading ar-status-clm'>{Status}</p>
                {!isNull(RejectionReason) ? <p className="tool_tip">
                    <span className='xsm_text text-light  multi-line-truncate text-wrap overflow-hidden' title={RejectionReason}> {RejectionReason}</span>
                </p> : null}
            </div>
        case 'Batch Acknowledged':
            return <div className="app_tooltip bottom grossary description claimStatus">
                <p className='Acknowledged-by-CH heading ar-status-clm'>{Status}</p>
                {!isNull(RejectionReason) ? <p className="tool_tip">
                    <span className='xsm_text text-light  multi-line-truncate text-wrap overflow-hidden' title={RejectionReason}> {RejectionReason}</span>
                </p> : null}
            </div>
        case 'Batch Acknowledged':
            return <div className="app_tooltip bottom grossary description claimStatus">
                <p className='Acknowledged-by-CH heading ar-status-clm'>{Status}</p>
                {!isNull(RejectionReason) ? <p className="tool_tip">
                    <span className='xsm_text text-light  multi-line-truncate text-wrap overflow-hidden' title={RejectionReason}> {RejectionReason}</span>
                </p> : null}
            </div>
        case 'Information Required':
            return <div className="app_tooltip bottom grossary description claimStatus">
                <p className=' information-Required ar-status-clm heading'>{Status}</p>
                {!isNull(RejectionReason) ? <p className="tool_tip">
                    <span className='xsm_text text-light  multi-line-truncate text-wrap overflow-hidden' title={RejectionReason}> {RejectionReason}</span>
                </p> : null}
            </div>
        case 'Pended':
            return <div className="app_tooltip bottom grossary description claimStatus">
                <p className='Hold heading ar-status-clm'>{Status}</p>
                {!isNull(RejectionReason) ? <p className="tool_tip">
                    <span className='xsm_text text-light  multi-line-truncate text-wrap overflow-hidden' title={RejectionReason}> {RejectionReason}</span>
                </p> : null}
            </div>
        case 'Batch Acknowledged with Errors':
            return <div className="app_tooltip bottom grossary description claimStatus">
                <p className='Batch-Acknowledged-Error  heading ar-status-clm'>{Status}</p>
                {!isNull(RejectionReason) ? <p className="tool_tip">
                    <span className='xsm_text text-light  multi-line-truncate text-wrap overflow-hidden' title={RejectionReason}> {RejectionReason}</span>
                </p> : null}
            </div>
        case 'Accepted for Processing':
            return <div className="app_tooltip bottom grossary description claimStatus">
                <p className='Accepted-by-Payer heading ar-status-clm'>{Status}</p>
                {!isNull(RejectionReason) ? <p className="tool_tip">
                    <span className='xsm_text text-light  multi-line-truncate text-wrap overflow-hidden' title={RejectionReason}> {RejectionReason}</span>
                </p> : null}
            </div>
        case 'Completed':
            return <div className="app_tooltip bottom grossary description claimStatus">
                <p className='Paid heading ar-status-clm'>{Status}</p>
                {!isNull(RejectionReason) ? <p className="tool_tip">
                    <span className='xsm_text text-light  multi-line-truncate text-wrap overflow-hidden' title={RejectionReason}> {RejectionReason}</span>
                </p> : null}
            </div>
        case 'Deleted':
            return <div className="app_tooltip bottom grossary description claimStatus">
                <p className='Denied heading ar-status-clm'>{Status}</p>
                {!isNull(RejectionReason) ? <p className="tool_tip">
                    <span className='xsm_text text-light  multi-line-truncate text-wrap overflow-hidden' title={RejectionReason}> {RejectionReason}</span>
                </p> : null}
            </div>
        case 'Crossover':
            return <p className='Crossover heading ar-status-clm'>{Status}</p>
        case 'Pending':
            return <p className='Hold heading ar-status-clm'>{Status}</p>
        case 'In Process':
            return <p className='Blue-Status heading ar-status-clm'>{Status}</p>
        default:
            return <div className="app_tooltip bottom grossary description claimStatus">
                <p className='heading ar-status-clm' style={{ backgroundColor: `rgba(${hexToRgb(Status)}, 0.07)`, color: getColorCode(Status) }} >{Status}</p>
                {!isNull(RejectionReason) ? <p className="tool_tip">
                    <span className='xsm_text text-light  multi-line-truncate text-wrap overflow-hidden' title={RejectionReason}> {RejectionReason}</span>
                </p> : null}
            </div>
    }

}

export default HandleStatus